import script from "./SingHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./SingHeader.vue?vue&type=script&setup=true&lang=ts"

import "./SingHeader.vue?vue&type=style&index=0&id=465295da&scoped=true&lang=less"

import exportComponent from "/Users/neal/Desktop/www/qingtv/qingtv-back-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-465295da"]])

export default __exports__